import '@babel/polyfill';
import Vue from 'vue';
import Vuetify from 'vuetify';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import showSnackbar from '@/helpers/snackbar';
import showNotificationDialog from '@/helpers/notification-dialog';
import rules from '@/rules';
import { isLoggedIn, isSuperuser } from '@/helpers/authentication';
import de from '@/locale/de';
import '@/globalComponents';
import '@/raven';
import '@/filters';

/*
  The default vue error handler does a console.error. (https://github.com/vuejs/vue/blob/dev/src/core/util/error.js)
  In the e2e tests we want to make a test fail when there's an error.
  Cypress listens on window.onerror, which won't be triggered.
*/
if (window.Cypress) {
  Vue.config.errorHandler = (error) => {
    window.Cypress.cy.onUncaughtException(error);
  };
}

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  lang: {
    locales: { de },
    current: 'de',
  },
  theme: {
    primary: '#e30513',
    secondary: '#c6c7c5',
    accent: '#000',
  },
});
Vue.prototype.$showSnackbar = showSnackbar;
Vue.prototype.$showNotificationDialog = showNotificationDialog;
Vue.prototype.$isLoggedIn = isLoggedIn;
Vue.prototype.$isSuperuser = isSuperuser;
Vue.prototype.$rules = rules;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
